import {v4 as uuidv4} from 'uuid';
import {Skill} from "@betrue/shared/interfaces";


export const SKILLS: Skill[] = [
  {
    id: uuidv4(),
    removed: false,
    key: 'java',
    label: 'java',
    usageCount: 30
  },
  {
    id: uuidv4(),
    removed: false,
    key: 'typescript',
    label: 'typescript',
    usageCount: 30
  },
  {
    id: uuidv4(),
    key: 'React',
    removed: false,
    label: 'React',
    usageCount: 30
  },
  {
    id: uuidv4(),
    removed: false,
    key: 'Angular',
    label: 'Angular',
    usageCount: 30
  }
  ,

  {
    id: uuidv4(),
    key: 'photoshop',
    label: 'photoshop',
    removed: false,
    usageCount: 30
  }
  ,
  {
    id: uuidv4(),
    removed: false,
    key: 'indesign',
    label: 'indesign',
    usageCount: 30
  },
  {
    id: uuidv4(),
    key: 'illustrator',
    removed: false,
    label: 'illustrator',
    usageCount: 30
  }
  ,
  {
    id: uuidv4(),
    key: 'afterEffect',
    label: 'afterEffect',
    removed: false,
    usageCount: 30

  }
  ,
  {
    id: uuidv4(),
    removed: false,
    key: 'elementor',
    label: 'elementor',
    usageCount: 30
  },
  {
    id: uuidv4(),
    removed: false,
    key: 'ingress',
    label: 'ingress',
    usageCount: 30
  },
  {
    id: uuidv4(),
    removed: false,
    key: 'kubernetes',
    label: 'kubernetes',
    usageCount: 30
  },
  {
    id: uuidv4(),
    key: 'docker',
    removed: false,

    label: 'docker',
    usageCount: 30
  },
  {
    id: uuidv4(),
    key: 'React',
    removed: false,

    label: 'React',
    usageCount: 30
  },
  {
    id: uuidv4(),
    removed: false,
    key: 'angularjs',
    label: 'angularjs',
    usageCount: 30
  },
  {
    id: uuidv4(),
    removed: false,
    key: 'terraform',
    label: 'terraform',
    usageCount: 30
  }
]
